import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  talentAccreditations: null,
  loading: false,
  total: 0,
  isDocumentModalVisible: false,
  isDocumentLoading: false,
  document: null,
  documents: [],
  accreditationName: '',
};

function formatAccreditations(accreditations) {
  return accreditations.map(accreditation => {
    return {
      ...accreditation,
      children: accreditation?.children?.length ? accreditation.children : undefined,
    };
  });
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;

  return {
    ...state,
    data: formatAccreditations(data),
    total,
    filteredTotal,
    loading: false,
  };
}

function onLoadDocumentRequest(state, { payload }) {
  return {
    ...state,
    accreditationName: payload.name,
    isDocumentLoading: true,
  };
}

function onLoadDocumentSuccess(state, { payload }) {
  return {
    ...state,
    document: payload.document,
    isDocumentLoading: false,
  };
}

function onLoadDocuments(state, { payload }) {
  return {
    ...state,
    documents: payload.documents,
    accreditationName: payload.name,
    isDocumentLoading: false,
  };
}

function onToggleDocumentModal(state, { payload }) {
  return {
    ...state,
    isDocumentModalVisible: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_DOCUMENT_REQUEST]: onLoadDocumentRequest,
  [actions.LOAD_DOCUMENT_SUCCESS]: onLoadDocumentSuccess,
  [actions.LOAD_DOCUMENTS]: onLoadDocuments,
  [actions.TOGGLE_DOCUMENT_MODAL]: onToggleDocumentModal,
  [actions.CLEAR_STORE]: onClearStore,
});
